import React from 'react'

import BoxScroll from '../../../SPRINTA/atoms/BoxScroll'
import Button from '../../../SPRINTA/atoms/Button'
import Loading from '../../../SPRINTA/atoms/Loading'
import FontIcon from '../../../SPRINTA/atoms/FontIcon'
import * as event from '../../Utils/event'

import T from '../../../SPRINTA/translate/T'

import style from './style.css'

export default class Gallery extends React.Component {

    loaded = false

    state = {
        images: [],
        selected: null,
        loading: true
    }

    componentWillMount() {
        this.componentWillReceiveProps(this.props)
    }

    componentWillReceiveProps( nextProps ) {
        if( nextProps.active )
            this.handleLoadData()

        // if( nextProps.selected )
        //     this.setState({
        //         selected: nextProps.selected
        //     })
    }


    handleLoadData( ) {
        if(this.loaded) return

        this.loaded = true

        event.loadGallery()
        .then( resp => {
            this.setState({
                images: resp.result,
                loading:  false
            })
        })
    }

    handleSelected(v) {
        // this.props.handleSelected(v)
        this.setState({
            selected: v
        })
    }

    render() {
        return (
            <div>
                {this.state.loading ? (
                    <Loading />
                ) : (
                    <div>
                        <span style={{ fontSize: '30px', color: '#2b2b29', float: 'left', marginBottom: '20px' }}>
                            {T.text('gallery_sprinta')}
                        </span>

                        <BoxScroll height='400px'>
                            { this.state.images.map( v => (
                                <div
                                    className={style.itemGallery}
                                    key={v.cat + v.image}
                                    onClick={() => this.handleSelected(v)}
                                    >

                                    <div className={`${style.select} ${v === this.state.selected ? style.selected : ''}`}>
                                        {v === this.state.selected && (
                                            <FontIcon name='check-o'/>
                                        )}
                                    </div>

                                    <img src={v.path} alt={v.image} />
                                </div>
                            ))}
                        </BoxScroll>

                        <div style={{ textAlign: 'right', marginTop: '20px', float: 'left', width: '100%' }}>
                            <Button
                                inline
                                theme='primary'
                                onClick={() => {
                                    this.props.handleSave(this.state.selected)
                                }}>
                                    {T.txt('save')}
                            </Button>
                        </div>
                    </div>
                )}

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/App/Components/Gallery/index.js